import useWebChatUIContext from '/druid/useWebChatUIContext';

export default function useStyleToEmotionObject() {
  return useWebChatUIContext().styleToEmotionObject;
}
